import { render, staticRenderFns } from "./common-container.vue?vue&type=template&id=ca0fa33c&scoped=true"
import script from "./common-container.vue?vue&type=script&lang=ts"
export * from "./common-container.vue?vue&type=script&lang=ts"
import style0 from "./common-container.vue?vue&type=style&index=0&id=ca0fa33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0fa33c",
  null
  
)

export default component.exports